import { translate as t } from "../../infrastructure/translate/localization";
import { adaptDataToCsv } from "../../infrastructure/adapters/adaptDataToCsv";
import generateCsv from "../../services/generateCsv";

export async function downloadEmployeesSelected(
  employees,
  isMexicanCompany = false
) {
  const { headers, rows } = adaptDataToCsv({
    type: "massiveEdit",
    data: employees,
    isMexicanCompany,
  });
  await generateCsv({
    title: t("employees-section.download-employee-list-title"),
    headers,
    rows,
    messageLog: "downloadEmployees",
  });
}
